import { FilterHandler } from '@btime/react-contexts'
import React from 'react'

import { PermissionChecker } from '../../session'
import ControlledModal from '../../../components/modals/ControlledModal'
import Header from './Header'
import Separator from '../../../components/helpers/Separator'
import PublicTokensLoader from './_load/PublicTokensLoader'
import PublicTokensTable from './table/PublicTokensTable'

const PublicTokensModal = props => {
  return (
    <ControlledModal width="68rem" {...props}>
      <PermissionChecker permission="listPublicToken">
        <Header />
        <Separator weight={2} />
        <FilterHandler>
          <PublicTokensLoader>
            <PublicTokensTable />
          </PublicTokensLoader>
          <Separator weight={4} />
        </FilterHandler>
      </PermissionChecker>
    </ControlledModal>
  )
}

export default PublicTokensModal
